<template>
    <div class="container-fluid"><!--dex-->
        <v-row v-if="stats_array&&stats_array.length == 0">
            <v-col>
                No data, pokemon is weak
            </v-col>
        </v-row>
        <v-row v-if="stats_array&&currStats">
            <v-col>
                Score: {{this.percentage}}%
            </v-col>
            <v-col>
               Current: {{this.product}}
            </v-col>
        </v-row>
        <v-row v-if="stats_array&&stats_array.length != 0">
            <v-col>
               CP
            </v-col>
            <v-col>
               Lvl
            </v-col>
            <v-col>
                A/D/S
            </v-col>
            <v-col>
               Sum
            </v-col>
            <v-col>
                Product
            </v-col>
        </v-row>
        <v-row v-for="stats in stats_array" :tooltip="stats.STAT" v-bind:key="[stats.IV,stats.lvl].toString()">
            <v-col>
                {{stats.cp}}
            </v-col>
            <v-col>
                {{stats.lvl}}
            </v-col>
            <v-col>
                {{stats.IV.join('/')}}
            </v-col>
            <v-col>
                {{stats.totalStat}}
            </v-col>
            <v-col>
                {{stats.productStat}}
            </v-col>
        </v-row>
<!--        <div class="row">-->
<!--            <div class="col">-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
    import vCol from "../../bootstrap/vCol.vue"
    import vRow from "../../bootstrap/vRow.vue"
    export default {
        name: "StatInfo",
        props:['stats_array','currStats'],
        components:{
            vCol,vRow
        },
        computed:{
            percentage: function () {
                // debugger // eslint-disable-line
                if(this.stats_array.length == 0){
                    return 0
                }
                return Math.round( ( (this.currStats.reduce( (a,b) => a * b )/1000)/ this.stats_array[0].productStat )*10000)/100
            },
            product: function () {
                // if(this.stats_array.length == 0){
                //     return 0
                // }
                return Math.round( (this.currStats.reduce( (a,b) => a * b )/1000)*100 )/100
            }
        },

    }
</script>

<style scoped>

</style>